module.exports = __webpack_public_path__ + "static/img/wx.1d823948.jpg";